export enum PriceVisibilityType {
    AUTO = 1,
    ALWAYS = 2,
    NEVER = 3
}
